let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2F9b6")).then(() => parcelRequire('csGky'));